/**
 * To recognise on and off campus geo coordinates.
 * Changed to composable by dgm11b
 * @author bmk11u
 */

import { ref } from 'vue'

export const useOnCampus = () => {

const GILMORE_HILL_BOUNDS = ref({ N: 55.875700, S: 55.867599, W: -4.299522, E: -4.277957 })
const GARSCUBE_BOUNDS = ref({ N: 55.907297, S: 55.898474, W: -4.326548, E: -4.303263 })

const isOnCampus = (lat, lng) => {
    let onCampus = false
    lat = parseFloat(lat)
    lng = parseFloat(lng)
    // Check Gilmore Hill
    if (lat < GILMORE_HILL_BOUNDS.value['N'] && lat > GILMORE_HILL_BOUNDS.value['S'] &&
      lng > GILMORE_HILL_BOUNDS.value['W'] && lng < GILMORE_HILL_BOUNDS.value['E']) {
      onCampus = true
    }
    if (!onCampus) {
      // Check Garscube
      if (lat < GARSCUBE_BOUNDS.value['N'] && lat > GARSCUBE_BOUNDS.value['S'] &&
        lng > GARSCUBE_BOUNDS.value['W'] && lng < GARSCUBE_BOUNDS.value['E']) {
        onCampus = true
      }
    }
    return onCampus
  }

  return {
    isOnCampus
  }

}